import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from '../../adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { MysqlCopySource } from 'app/model/pipeline/copysource/mysql.copysource';
import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { ValueAdapter } from '../../value.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(MysqlCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*'
    }
})
export class MysqlCopySourceAdapter extends CopySourceAdapter<MysqlCopySource, Model.MysqlSource> {
    protected override async _toResource(copySource: MysqlCopySource): Promise<Model.MysqlSource> {
        const result: Model.MysqlSource = this.getCommonCopySourceProperties(
            copySource,
            Metamodel.modelFor(MysqlCopySource).name
        );
        if (copySource.mode === 'query') {
            result.query = ValueAdapter.toResource(copySource, MysqlCopySource.READER_QUERY);
        }
        return result;
    }

    protected override async _toModel(
        resource: Model.MysqlSource,
        copyActivity: CopyActivity
    ): Promise<MysqlCopySource> {
        return this._toTabularModel(resource, copyActivity, MysqlCopySource.MODEL);
    }
}
